import { render, staticRenderFns } from "./CustomerLevel.vue?vue&type=template&id=a5de9868&scoped=true&"
import script from "./CustomerLevel.vue?vue&type=script&lang=js&"
export * from "./CustomerLevel.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLevel.vue?vue&type=style&index=0&id=a5de9868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5de9868",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VProgressLinear,VRow})
